import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { z } from "zod";
import { resolvePlayback } from "./media-access.server";

const input = z.object({
  scope: z.enum(["post", "impact_media", "impact_update"]),
  id: z.string().uuid(),
});

export const getVideoPlayback = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => input.parse(data))
  .handler(async ({ data }) => {
    const header = getRequest().headers.get("authorization");
    const token = header?.toLowerCase().startsWith("bearer ") ? header.slice(7) : null;
    return resolvePlayback(data.scope, data.id, token);
  });
